import React, { PropTypes } from 'react';
import { Document, Page } from 'react-pdf/build/entry.webpack';
import RemoveFile from './removeFile';
import FileName from './fileName';

const PDFPreview = props => {
  const {
    url,
    removeFile,
    fileName,
    showFileName,
    openGallery,
    showGallery,
    fullSize,
  } = props;

  return (
    <div style={{ width: '100px', position: 'relative', display: 'inline-block' }}>
      <div style={{ height: '100%' }} onTouchTap={showGallery && openGallery}>
        <div style={{ cursor: showGallery ? 'pointer' : 'default', border: fullSize ? '' : '2px solid #D3D3D3', width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Document file={url}>
            <Page pageNumber={1} width={fullSize ? 450 : 85} />
          </Document>
        </div>
        {showFileName && <FileName fileName={fileName} width="100px" vertical />}
      </div>
      {removeFile && <RemoveFile
        top="67%"
        left="75%"
        removeFile={() => removeFile(url)}
      />}
    </div>
  );
};

PDFPreview.propTypes = {
  url: PropTypes.string,
  removeFile: PropTypes.func,
  fileName: PropTypes.string,
  showFileName: PropTypes.bool,
  openGallery: PropTypes.func,
  showGallery: PropTypes.bool,
  fullSize: PropTypes.bool,
};

export default PDFPreview;



// WEBPACK FOOTER //
// ./src/app/components/extra/filePreview/pdfPreview.jsx